import { dateToyyyyMMdd } from "../../../../../util/date";
import {
  OpretFirmaDTO,
  OpretFirmaStep1Formik,
  OpretFirmaStep2Formik,
} from "../../opretFirmaInterface";

export const getOpretFOFirmaDTO = ({
  step1,
  step2,
}: {
  step1: OpretFirmaStep1Formik;
  step2: OpretFirmaStep2Formik;
}): OpretFirmaDTO => {
  const {
    advokatVirksomhed,
    navn,
    periodeFraDato,
    andenAdresse,
    virksomhedsform,
    udenlandskCvr,
  } = step1;
  const {
    ean,
    email,
    emailFaktura,
    selskabstype,
    fakturaAfsend,
    phone,
    website,
  } = step2;
  return {
    advokatVirksomhed,
    beliggenhedsadresse: {
      ...andenAdresse,
      landekode: "FO",
    },
    bemaerkninger: null,
    cvrNr: null,
    ean,
    email,
    fakturaAfsend: fakturaAfsend ?? null,
    fakturaEmail: emailFaktura,
    kommuneNr: null,
    kredsNr: 1,
    navn1: navn,
    navn2: "",
    navn3: "",
    periodeFraDato: periodeFraDato ? dateToyyyyMMdd(periodeFraDato) : null,
    pnr: null,
    regionNr: null,
    retskredsNr: null,
    selskabstype: selskabstype ? parseInt(selskabstype) : null,
    tlf: phone,
    udenlandskVirksomhedsId: udenlandskCvr ?? null,
    virksomhedsform: virksomhedsform ?? null,
    webAdresse: website,
  };
};
